module.exports = __webpack_public_path__ + "static/media/screenshot_extended_en.2a4eae3b.png";